export default {"src":"/_next/static/media/loading-button-icon.6ee471d2.webp","height":202,"width":200,"blurWidth":0,"blurHeight":0};